import { io } from 'socket.io-client';
const GMAIL_SOCKET_URL = 'https://wha.bukingmaster.com';
const SOCKET_URL = 'https://wha.bukingmaster.com';

const socket = io(SOCKET_URL, {
    path: '/socwh/socket.io',
    transports: ['websocket'],
    autoConnect: true,
});
const gmailSocket = io(GMAIL_SOCKET_URL, {
    path: '/socgm/socket.io',
    transports: ['websocket'],
    autoConnect: true,
});
export { socket, gmailSocket };